import React, { Component } from 'react'
import "./Confirmation.scss"
import Loader from 'components/Loader'
import { orders, services } from '@src/services/api'
import confirmationOrderImg from './images/confirmacionCompraLimpieza.png'
import errorOrdenImg from './images/fallo_pago.png'
import * as paths from 'utils/paths'

class CreateOrder extends Component {
  constructor (props) {
    super(props)
    this.state = {
      creatingOrder: true,
      uuid: null,
      success: false
    }
  }

  componentDidMount () {
    this.createOrder()
  }

  componentDidUpdate () {
    const { creatingOrder, uuid } = this.state

    if (creatingOrder && uuid !== null) {
      this.backgroundJob()
    }
  }

  createOrder () {
    const { params } = this.props;

    orders.create(params)
      .then(response => {
        this.setState({ uuid: response.response.uuid })
      })
      .catch(error => {
        this.setState({ creatingOrder: false })
      });
  }

  backgroundJob() {
    const { uuid } = this.state

    services.backgroundJob(uuid)
      .then((response)=> {
        if (response.status === 'success' && response.orderId !== null) {
          this.setState({ creatingOrder: false, success: true })
        } else {
          this.setState({ creatingOrder: false })
        }
      })
      .catch(error => {
        this.setState({ creatingOrder: false })
      });
  }

  render () {
    const { creatingOrder, success } = this.state
    const { userId } = this.props.params

    if (creatingOrder) {
      return (
        <div className="create-order-loader">
          <Loader text="Estamos procesando tu pago ..."/>
        </div>
      )
    }

    if (success) {
      return(
        <div className='Success-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <a href={paths.userNextServices(userId)} className='boxclose'>x</a>
            <h1>Tu compra ha sido aprobada.</h1>
            <img src={confirmationOrderImg} />
            <p>Entregaremos tu kit dentro de 48 horas en la misma dirección de tu servicio.</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className='Success-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <a href={paths.userNextServices(userId)} className='boxclose'>x</a>
            <h1>!Lo sentimos!</h1>
            <h1>No pudimos completar tu compra.</h1>
            <img src={errorOrdenImg} />
            <p>Te recomendamos revisar tu forma de pago.</p>
          </div>
        </div>
      );
    }
  }
}
  
export default CreateOrder


// WEBPACK FOOTER //
// ./src/screens/App/screens/Orders/screens/Confirmation/Confirmation.js